import React from 'react'
import { useSelector } from 'react-redux'

const About = () => {
    const {sliders} = useSelector((state) => state.sliders);

  return (
    <div className='py-5'
    style={{ 
      backgroundColor: '#0016A9'
     }}
    >
              <p className='small-header text-center mt-4 text-light'> ABOUT ME </p>
              <div className='row m-4 align-items-baseline'
              
              >
                    <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2 container'
                    
                    >
                      <center>
                        <img src={'./assets/images/profileImage.jpg'} width={'250px'} height={'250px'}
                        style={{ 
                          borderRadius: '50%',
                          border: '5px',
                          borderStyle: 'double',
                          borderColor: 'white',
                          marginTop: '5px'
                         }}
                        />
                      </center>
                    </div>
                    <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-5 text-light container'
                    style={{ 
                        textAlign: 'justify'
                     }}
                    >
                    <p className='mt-0'><b>Hello,</b> </p>
                    <p className='mb-5'>
                    I am Usman Abubakar. A computer science graduate, a keen and committed full stack software engineer
                    with eight(8) years experience in software development for both web and mobile, experience in developers community management and leadership.
                    Able to work with groups, productive under pressure, always ready to expand knowledge base. 
                    </p>
                    </div>
              </div>
        </div>
  )
}

export default About